import { Link } from 'react-router-dom';

export default function OverseasOwnersBanner() {
  return (
    <section className="py-16 px-4 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-slate-950 to-slate-900 border border-slate-700">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://public.readdy.ai/ai/img_res/b0e676c0f0cccd937872da1f4a8d627a.jpg"
              alt="Tokyo luxury property"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="relative z-10 grid md:grid-cols-2 gap-8 items-center p-8 md:p-12">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/20 border border-amber-500/30 rounded-full mb-6">
                <i className="ri-global-line text-amber-400 text-lg"></i>
                <span className="text-amber-300 text-sm font-medium">For Overseas Property Owners</span>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
                Complete Peace of Mind<br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-200">
                  from Overseas
                </span>
              </h2>

              <p className="text-slate-300 text-base md:text-lg mb-6 leading-relaxed">
                Full-service minpaku management in Tokyo with English support, tax filing assistance, and transparent monthly reporting. Manage your Tokyo property from anywhere in the world.
              </p>

              <div className="flex flex-wrap gap-4 mb-8">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center">
                    <i className="ri-building-line text-amber-400 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-white font-bold text-xl">150+</div>
                    <div className="text-slate-400 text-xs">Properties</div>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center">
                    <i className="ri-star-line text-amber-400 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-white font-bold text-xl">98%</div>
                    <div className="text-slate-400 text-xs">Satisfaction</div>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-amber-400 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-white font-bold text-xl">24/7</div>
                    <div className="text-slate-400 text-xs">Support</div>
                  </div>
                </div>
              </div>

              <Link
                to="/overseas-owners"
                className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-amber-500/50 whitespace-nowrap"
              >
                <span>Learn More About Our Services</span>
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
            </div>

            <div className="hidden md:block">
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20international%20business%20team%20working%20with%20laptop%20and%20documents%20in%20modern%20Tokyo%20office%20with%20large%20windows%20showing%20Tokyo%20tower%20and%20cityscape%20diverse%20team%20discussing%20property%20management%20reports%20and%20analytics%20high%20quality%20corporate%20photography%20style%20sophisticated%20atmosphere&width=600&height=700&seq=overseas-banner-team-001&orientation=portrait"
                  alt="Professional property management team"
                  className="rounded-xl shadow-2xl border border-slate-700"
                />
                <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-2xl p-4 border border-slate-200">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                      <i className="ri-check-line text-green-600 text-2xl"></i>
                    </div>
                    <div>
                      <div className="text-slate-900 font-bold text-sm">English Support</div>
                      <div className="text-slate-600 text-xs">Available 24/7</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}